"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useErrorBoundary = exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _find = _interopRequireDefault(require("lodash/find"));
var _react = _interopRequireWildcard(require("react"));
var _reactErrorBoundary = require("react-error-boundary");
var _ErrorFallback = _interopRequireDefault(require("./ErrorFallback"));
var _ErrorBoundaryContext = require("./ErrorBoundaryContext");
var _excluded = ["children", "FallbackComponent", "DebugErrorComponent", "debugErrorComponentProps"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var propTypes = {
  children: _propTypes["default"].node,
  FallbackComponent: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].func]),
  DebugErrorComponent: _propTypes["default"].func,
  debugErrorComponentProps: _propTypes["default"].object
};
var useErrorBoundary = function useErrorBoundary() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    onReset = _ref.onReset,
    recoveryState = _ref.recoveryState,
    text = _ref.text,
    buttonText = _ref.buttonText,
    knownErrors = _ref.knownErrors;
  var setError = (0, _reactErrorBoundary.useErrorHandler)();
  var _useErrorBoundaryCont = (0, _ErrorBoundaryContext.useErrorBoundaryContext)(),
    recoveryStateRef = _useErrorBoundaryCont.recoveryStateRef,
    onResetRef = _useErrorBoundaryCont.onResetRef,
    displayInfoRef = _useErrorBoundaryCont.displayInfoRef;
  displayInfoRef.current.text = text;
  displayInfoRef.current.buttonText = buttonText;
  onResetRef.current = onReset;
  recoveryStateRef.current = recoveryState;
  var catchError = (0, _react.useCallback)(function () {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _error = _ref2.error,
      _onReset = _ref2.onReset,
      _text = _ref2.text,
      _recoveryState = _ref2.recoveryState,
      _buttonText = _ref2.buttonText;
    if (!_error) {
      return;
    }
    var knownError = (0, _find["default"])(knownErrors, function (_ref3) {
      var message = _ref3.message;
      return message === _error.message;
    });
    onResetRef.current = _onReset;
    displayInfoRef.current.text = _text;
    displayInfoRef.current.hint = knownError === null || knownError === void 0 ? void 0 : knownError.hint;
    displayInfoRef.current.buttonText = _buttonText;
    recoveryStateRef.current = _recoveryState;
    setError(_error);
  }, [setError, onResetRef, recoveryStateRef, displayInfoRef, knownErrors]);
  return catchError;
};
exports.useErrorBoundary = useErrorBoundary;
var ErrorBoundary = function ErrorBoundary(_ref4) {
  var children = _ref4.children,
    FallbackComponent = _ref4.FallbackComponent,
    DebugErrorComponent = _ref4.DebugErrorComponent,
    debugErrorComponentProps = _ref4.debugErrorComponentProps,
    rest = _objectWithoutProperties(_ref4, _excluded);
  var onResetRef = (0, _react.useRef)();
  var recoveryStateRef = (0, _react.useRef)();
  var displayInfoRef = (0, _react.useRef)({});
  var Component = FallbackComponent || _ErrorFallback["default"];
  return /*#__PURE__*/_react["default"].createElement(_ErrorBoundaryContext.ErrorBoundaryContext.Provider, {
    value: {
      onResetRef: onResetRef,
      recoveryState: function recoveryState() {
        return recoveryStateRef.current;
      },
      recoveryStateRef: recoveryStateRef,
      displayInfoRef: displayInfoRef
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactErrorBoundary.ErrorBoundary, _extends({
    FallbackComponent: function FallbackComponent(props) {
      return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, props, debugErrorComponentProps, {
        DebugErrorComponent: DebugErrorComponent,
        displayInfo: displayInfoRef.current
      }));
    }
  }, rest, {
    onReset: function onReset() {
      var _onResetRef$current;
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return (_onResetRef$current = onResetRef.current) === null || _onResetRef$current === void 0 ? void 0 : _onResetRef$current.call.apply(_onResetRef$current, [onResetRef].concat(args));
    }
  }), children));
};
ErrorBoundary.propTypes = propTypes;
ErrorBoundary.displayName = "ErrorBoundary";
var _default = ErrorBoundary;
exports["default"] = _default;